module.exports = __webpack_public_path__ + "static/zuzhi-d0521193825150fefd8ebf9d0a2eca2e.png";